import * as yup from "yup";
import { passwordYupValidation } from "../helpers/passwordHelper";

export const expiredPasswordSchema = yup.object({
  "Current Password": yup.string().required(),
  "New Password": passwordYupValidation().required(),
  "Confirm Password": yup.string().oneOf([yup.ref("New Password"), null]),
});
